import clsx from 'clsx';
import css from '../link/Link.module.css'
import { Paragraph } from '../../../text';

export interface LinkTextProps {
  className?: string;
  caption: string;
}

const LinkText: React.FC<LinkTextProps> = (props: LinkTextProps) => {
  return (
    <Paragraph
      className={clsx(props.className, css.captionText)}
      text={props.caption}
      underline={true}
    />
  );
};

export default LinkText;
